module.exports = __webpack_public_path__ + "img/orange_111.6451d41f.png";